import React, { FC, ReactNode } from "react";
import { isFunction } from "lodash";

import {
  AccordionItem as AccordionItemUI,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion";

type ExpandableContent = ({ isExpanded }: { isExpanded: boolean }) => ReactNode;

interface AccordionItemProps {
  headContent: ReactNode | ExpandableContent;
  content: ReactNode | ExpandableContent;
  itemHeadClassName?: string;
  itemContentClassName?: string;
}

const AccordionItem: FC<AccordionItemProps> = ({
  headContent,
  content,
  itemHeadClassName = "",
  itemContentClassName = "",
}) => {
  return (
    <AccordionItemUI>
      <AccordionItemState>
        {({ expanded }) => (
          <div className="transition-all">
            <AccordionItemHeading className={itemHeadClassName}>
              <AccordionItemButton>
                {isFunction(headContent)
                  ? headContent({ isExpanded: expanded ?? false })
                  : headContent}
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={itemContentClassName}>
              {isFunction(content)
                ? content({ isExpanded: expanded ?? false })
                : content}
            </AccordionItemPanel>
          </div>
        )}
      </AccordionItemState>
    </AccordionItemUI>
  );
};

export default AccordionItem;
